import { useSelector } from 'react-redux'
import logo_tf from '../../assets/images/logo_blue.svg'
import { selectTranslations } from '../../services/i18n/i18nSlice'
import { BASE_URL } from '../../config/constants'

export default function MobileScreen () {
    const t = useSelector(selectTranslations)

    return(
        <div className=' d-flex flex-column align-items-center pt-4 px-3 text-center'>
            <img src={logo_tf} alt='' style={{maxWidth:'180px'}} className='mt-5' />
            <h1 className='mt-3'>Collegati dal tuo PC</h1>
            <p>Per sfruttare al meglio tutte le potenzialità della piattaforma collegati all'area amministrativa dal tuo PC, inserisci questo URL per collegarti:</p>
            <p className='text-tf'> <strong>{BASE_URL}/admin</strong></p>
        </div>
    )
}